import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--linen))] text-[hsl(var(--ink))]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
